import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPromptTextToImage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"prompt-text-to-image"} maskId="square-filled-radius-0-stroke-1-IconPromptTextToImage"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H5V15H6V20H6.79297L16 10.793L20 14.793V6H13V5H21V21Z" fill="currentColor"/><path d="M10 5H9V4H6V11H7V12H4V11H5V4H2V5H1V3H10V5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPromptTextToImage;
